import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import ProductGroupItem from '../ProductGroupItem';
import { constants } from '@wsb/guac-widget-core';

class GridLayoutRow extends React.Component {
  render() {
    const {
      products,
      gridSize,
      cardType,
      actionLinkText,
      showProductPrice,
      imageOverlayOpacity,
      category,
      renderMode,
      shopWidgetPageId,
      shopWidgetRoute,
      showActionLink
    } = this.props;

    const {
      Component: {
        CommerceCardOverlay,
        Grid,
        Grid: { Cell }
      }
    } = UX2;

    const { renderModes } = constants;

    return (
      <Grid
        xs={ gridSize.xs }
        sm={ gridSize.sm }
        spacingXs='xsmall'
        spacingSm='small'
        spacingMd='medium'
      >
        { products.map(product => (
          <Cell xs={ 1 } sm={ 1 } key={ product.id }>
            <ProductGroupItem
              productItemAs={ CommerceCardOverlay }
              isGridLayout
              shopWidgetPageId={ shopWidgetPageId }
              shopWidgetRoute={ shopWidgetRoute }
              product={ product }
              category={ category }
              linkText={ showActionLink ? actionLinkText : null }
              isPriceShown={ showProductPrice }
              isImageShown={
                product.has_images ||
                renderMode === renderModes.DISPLAY ||
                renderMode === renderModes.ADD
              }
              renderMode={ renderMode }
              overlayAlpha={ imageOverlayOpacity }
              cardType={ cardType }
            />
          </Cell>
        )) }
      </Grid>
    );
  }
}

GridLayoutRow.propTypes = {
  gridSize: PropTypes.object,
  cardType: PropTypes.string,
  products: PropTypes.array,
  imageOverlayOpacity: PropTypes.number,
  showProductPrice: PropTypes.bool,
  showActionLink: PropTypes.bool,
  actionLinkText: PropTypes.string,
  category: PropTypes.string,
  renderMode: PropTypes.string,
  shopWidgetPageId: PropTypes.any,
  shopWidgetRoute: PropTypes.any
};

export default GridLayoutRow;
